import { createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { creatorSubscriptionSaga } from "./saga";

export const initialState = {
  creatorSubscriptions: {
    loading: false,
    error: null,
    subscriptions: []
  },

  creatorSubscriptionDetails: {
    loading: false,
    error: null,
    subscription: null,
    currentLimit: null,
    usageHistory: [],
    pagination: {}
  },

  changePlan: {
    loading: false,
    success: false,
    error: null,
    subscriptionId: null
  }
};

export const CreatorSubscriptionSlice = createSlice({
  name: "creatorSubscription",
  initialState,
  reducers: {
    /* ---------------- Plan History Modal ---------------- */
    fetchCreatorSubscriptionsRequest(state) {
      state.creatorSubscriptions.loading = true;
      state.creatorSubscriptions.error = null;
    },

    fetchCreatorSubscriptionsSuccess(state, action) {
      state.creatorSubscriptions.loading = false;
      state.creatorSubscriptions.subscriptions = action.payload.subscriptions;
    },

    fetchCreatorSubscriptionsFailure(state, action) {
      state.creatorSubscriptions.loading = false;
      state.creatorSubscriptions.error = action.payload;
    },

    /* ---------------- Subscription Details Page ---------------- */
    fetchCreatorSubscriptionDetailsRequest(state) {
      state.creatorSubscriptionDetails.loading = true;
      state.creatorSubscriptionDetails.error = null;
    },

    fetchCreatorSubscriptionDetailsSuccess(state, action) {
      state.creatorSubscriptionDetails.loading = false;
      state.creatorSubscriptionDetails.subscription =
        action.payload.subscription;
      state.creatorSubscriptionDetails.currentLimit =
        action.payload.currentLimit;
      state.creatorSubscriptionDetails.usageHistory =
        action.payload.usageHistory;

      state.creatorSubscriptionDetails.pagination = action.payload.pagination;
    },

    fetchCreatorSubscriptionDetailsFailure(state, action) {
      state.creatorSubscriptionDetails.loading = false;
      state.creatorSubscriptionDetails.error = action.payload;
    },

    /* ---------------- Change Plan ---------------- */
    changePlanRequest(state) {
      state.changePlan.loading = true;
      state.changePlan.success = false;
      state.changePlan.error = null;
    },

    changePlanSuccess(state, action) {
      state.changePlan.loading = false;
      state.changePlan.success = true;
      state.changePlan.subscriptionId = action.payload.subscriptionId;
      state.changePlan.error = null;
    },

    changePlanFailure(state, action) {
      state.changePlan.loading = false;
      state.changePlan.success = false;
      state.changePlan.error = action.payload;
    }
  }
});

export const useCreatorSubscriptionSlice = () => {
  useInjectReducer(
    CreatorSubscriptionSlice.name,
    CreatorSubscriptionSlice.reducer
  );
  useInjectSaga(CreatorSubscriptionSlice.name, creatorSubscriptionSaga);
  const actions = useMemo(() => CreatorSubscriptionSlice.actions, []);
  return { actions };
};

export const { actions: creatorSubscriptionActions } = CreatorSubscriptionSlice;
export default CreatorSubscriptionSlice.reducer;
